// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-data-table-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px;
  justify-content: flex-end;
}

.v-data-table-footer__items-per-page {
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-data-table-footer__items-per-page > span {
  padding-inline-end: 8px;
}
.v-data-table-footer__items-per-page > .v-select {
  width: 90px;
}

.v-data-table-footer__info {
  display: flex;
  justify-content: flex-end;
  min-width: 116px;
  padding: 0 16px;
}

.v-data-table-footer__pagination {
  display: flex;
  align-items: center;
  margin-inline-start: 16px;
}

.v-data-table-footer__page {
  padding: 0 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDataTable/VDataTableFooter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".v-data-table-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 4px;\n  justify-content: flex-end;\n}\n\n.v-data-table-footer__items-per-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.v-data-table-footer__items-per-page > span {\n  padding-inline-end: 8px;\n}\n.v-data-table-footer__items-per-page > .v-select {\n  width: 90px;\n}\n\n.v-data-table-footer__info {\n  display: flex;\n  justify-content: flex-end;\n  min-width: 116px;\n  padding: 0 16px;\n}\n\n.v-data-table-footer__pagination {\n  display: flex;\n  align-items: center;\n  margin-inline-start: 16px;\n}\n\n.v-data-table-footer__page {\n  padding: 0 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
